import './page-content.component.scss'

const actionBtns = document.querySelectorAll('.page-content__btn')

actionBtns.forEach(btn => {
	const btnText = btn.textContent

	btn.addEventListener('click', function () {
		const parent = btn.closest('.page-content')
		const contentSection = parent.querySelector('.page-content__text')

		parent.classList.toggle('js-hide')

		if (parent.classList.contains('js-hide')) {
			btn.textContent = btnText
			contentSection.style.display = 'none'
		} else {
			btn.textContent = 'Hide Description'
			contentSection.style.display = 'block'
		}
	})
})
